export const BRAND = {
  name: 'Codigrate',
  officialName: 'Codigrate OU',
  motto: 'UI, UX and software solutions',
  bio: `Coding is a creative craft. Discover our apps, plugins, themes and tools to boost your creativity too`,
  establishDate: '2021-07-02',
  logo: {
    main: './assets/brand/min/logo/brand-logo.min.webp',
    inlineLight: './assets/brand/min/logo/light/inline.min.webp',
    inlineDark: './assets/brand/min/logo/dark/inline.min.webp',
    error: './assets/common/404.webp',
    maintenance: './assets/common/maintenance.webp',
  },
  wallpapers: [
    {
      min: './assets/brand/min/wallpaper/inline/branches/color.min.webp',
      raw: './assets/brand/wallpaper/inline/branches/color.png'
    },
    {
      min: './assets/brand/min/wallpaper/inline/branches/dark.min.webp',
      raw: './assets/brand/wallpaper/inline/branches/dark.png'
    },
    {
      min: './assets/brand/min/wallpaper/inline/branches/light.min.webp',
      raw: './assets/brand/wallpaper/inline/branches/light.png'
    },
    {
      min: './assets/brand/min/wallpaper/inline/branches/dynamic.min.webp',
      raw: './assets/brand/wallpaper/inline/branches/dynamic.heic'
    },
  ],
  mobileWallpapers: [
    {
      min: './assets/brand/min/wallpaper/logo/branches/mobile/color.min.webp',
      raw: './assets/brand/wallpaper/logo/branches/mobile/color.png'
    },
    {
      min: './assets/brand/min/wallpaper/logo/branches/mobile/dark.min.webp',
      raw: './assets/brand/wallpaper/logo/branches/mobile/dark.png'
    },
    {
      min: './assets/brand/min/wallpaper/logo/branches/mobile/light.min.webp',
      raw: './assets/brand/wallpaper/logo/branches/mobile/light.png'
    },
  ],
  badges: [
    {
      min: './assets/brand/min/badge/business-partner-light.min.webp',
      raw: './assets/brand/badge/business-partner-light.png'
    },
    {
      min: './assets/brand/min/badge/business-partner-dark.min.webp',
      raw: './assets/brand/badge/business-partner-dark.png'
    },
  ],
};
